/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuccessfulActionResponse as DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse } from '../../models/Digiwork/MaitreD/Api/Configuration/Model/CustomResponses/successful-action-response';
import { BillTypeEnum as DigiworkMaitreDDomenModelBillTypeEnum } from '../../models/Digiwork/MaitreD/Domen/Model/bill-type-enum';

export interface PrintBill$Params {
  billId: string;
  billType?: DigiworkMaitreDDomenModelBillTypeEnum;
  discount?: number;
}

export function printBill(http: HttpClient, rootUrl: string, params: PrintBill$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse>> {
  const rb = new RequestBuilder(rootUrl, printBill.PATH, 'post');
  if (params) {
    rb.path('billId', params.billId, {});
    rb.query('billType', params.billType, {});
    rb.query('discount', params.discount, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse>;
    })
  );
}

printBill.PATH = '/api/orders/bills/{billId}/print-bill';
